<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="20" viewBox="0 0 26 20" fill="none">
    <path
      d="M2 2H24"
      stroke="url(#paint0_linear_5361_3349)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M2 10H17"
      stroke="url(#paint1_linear_5361_3349)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M2 18H11"
      stroke="url(#paint2_linear_5361_3349)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5361_3349"
        x1="2"
        y1="2"
        x2="2.09165"
        y2="4.00266"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5361_3349"
        x1="2"
        y1="10"
        x2="2.1341"
        y2="11.9979"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5361_3349"
        x1="2"
        y1="18"
        x2="2.22174"
        y2="19.982"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
